import api from './api'
import type { LoginRequest, LoginResponse, User } from '@/types'

export const authService = {
  async login(credentials: LoginRequest): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/login', credentials)
    return response.data
  },

  async me(): Promise<User> {
    const response = await api.get<User>('/auth/me')
    return response.data
  },

  async refresh(): Promise<LoginResponse> {
    const response = await api.post<LoginResponse>('/auth/refresh')
    return response.data
  },

  async listUsers(): Promise<User[]> {
    const response = await api.get<User[]>('/admin/users')
    return response.data
  },

  async createUser(user: { username: string; password: string; admin: boolean }): Promise<User> {
    const response = await api.post<User>('/admin/users', user)
    return response.data
  },

  async updateUser(id: string, user: Partial<{ username: string; password: string; admin: boolean }>): Promise<User> {
    const response = await api.put<User>(`/admin/users/${id}`, user)
    return response.data
  },

  async deleteUser(id: string): Promise<void> {
    await api.delete(`/admin/users/${id}`)
  },

  async changePassword(currentPassword: string, newPassword: string): Promise<void> {
    await api.post('/auth/change-password', { currentPassword, newPassword })
  }
}
